import React from 'react';

const USAFlagSVGIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="20"
      viewBox="0 0 28 20"
      fill="none"
    >
      <rect width="28" height="20" rx="2" fill="white" />
      <mask
        id="mask0_3085_38838"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="20"
      >
        <rect width="28" height="20" rx="2" fill="white" />
      </mask>
      <g mask="url(#mask0_3085_38838)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28 0H0V1.33333H28V0ZM28 2.66667H0V4H28V2.66667ZM0 5.33333H28V6.66667H0V5.33333ZM28 8H0V9.33333H28V8ZM0 10.6667H28V12H0V10.6667ZM28 13.3333H0V14.6667H28V13.3333ZM0 16H28V17.3333H0V16ZM28 18.6667H0V20H28V18.6667Z"
          fill="#D02F44"
        />
        <rect width="12" height="9.33333" fill="#46467F" />
        <g filter="url(#filter0_d_3085_38838)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.66659 1.9987C2.66659 2.36689 2.36811 2.66536 1.99992 2.66536C1.63173 2.66536 1.33325 2.36689 1.33325 1.9987C1.33325 1.63051 1.63173 1.33203 1.99992 1.33203C2.36811 1.33203 2.66659 1.63051 2.66659 1.9987ZM5.33325 1.9987C5.33325 2.36689 5.03478 2.66536 4.66659 2.66536C4.2984 2.66536 3.99992 2.36689 3.99992 1.9987C3.99992 1.63051 4.2984 1.33203 4.66659 1.33203C5.03478 1.33203 5.33325 1.63051 5.33325 1.9987ZM7.33325 2.66536C7.70144 2.66536 7.99992 2.36689 7.99992 1.9987C7.99992 1.63051 7.70144 1.33203 7.33325 1.33203C6.96506 1.33203 6.66659 1.63051 6.66659 1.9987C6.66659 2.36689 6.96506 2.66536 7.33325 2.66536ZM10.6666 1.9987C10.6666 2.36689 10.3681 2.66536 9.99992 2.66536C9.63173 2.66536 9.33325 2.36689 9.33325 1.9987C9.33325 1.63051 9.63173 1.33203 9.99992 1.33203C10.3681 1.33203 10.6666 1.63051 10.6666 1.9987ZM3.33325 3.9987C3.70144 3.9987 3.99992 3.70022 3.99992 3.33203C3.99992 2.96384 3.70144 2.66536 3.33325 2.66536C2.96506 2.66536 2.66659 2.96384 2.66659 3.33203C2.66659 3.70022 2.96506 3.9987 3.33325 3.9987ZM6.66659 3.33203C6.66659 3.70022 6.36811 3.9987 5.99992 3.9987C5.63173 3.9987 5.33325 3.70022 5.33325 3.33203C5.33325 2.96384 5.63173 2.66536 5.99992 2.66536C6.36811 2.66536 6.66659 2.96384 6.66659 3.33203ZM8.66658 3.9987C9.03477 3.9987 9.33325 3.70022 9.33325 3.33203C9.33325 2.96384 9.03477 2.66536 8.66658 2.66536C8.2984 2.66536 7.99992 2.96384 7.99992 3.33203C7.99992 3.70022 8.2984 3.9987 8.66658 3.9987ZM10.6666 4.66536C10.6666 5.03355 10.3681 5.33203 9.99992 5.33203C9.63173 5.33203 9.33325 5.03355 9.33325 4.66536C9.33325 4.29717 9.63173 3.9987 9.99992 3.9987C10.3681 3.9987 10.6666 4.29717 10.6666 4.66536ZM7.33325 5.33203C7.70144 5.33203 7.99992 5.03355 7.99992 4.66536C7.99992 4.29717 7.70144 3.9987 7.33325 3.9987C6.96506 3.9987 6.66659 4.29717 6.66659 4.66536C6.66659 5.03355 6.96506 5.33203 7.33325 5.33203ZM5.33325 4.66536C5.33325 5.03355 5.03478 5.33203 4.66659 5.33203C4.2984 5.33203 3.99992 5.03355 3.99992 4.66536C3.99992 4.29717 4.2984 3.9987 4.66659 3.9987C5.03478 3.9987 5.33325 4.29717 5.33325 4.66536ZM1.99992 5.33203C2.36811 5.33203 2.66659 5.03355 2.66659 4.66536C2.66659 4.29717 2.36811 3.9987 1.99992 3.9987C1.63173 3.9987 1.33325 4.29717 1.33325 4.66536C1.33325 5.03355 1.63173 5.33203 1.99992 5.33203ZM3.99992 5.9987C3.99992 6.36689 3.70144 6.66536 3.33325 6.66536C2.96506 6.66536 2.66659 6.36689 2.66659 5.9987C2.66659 5.63051 2.96506 5.33203 3.33325 5.33203C3.70144 5.33203 3.99992 5.63051 3.99992 5.9987ZM5.99992 6.66536C6.36811 6.66536 6.66659 6.36689 6.66659 5.9987C6.66659 5.63051 6.36811 5.33203 5.99992 5.33203C5.63173 5.33203 5.33325 5.63051 5.33325 5.9987C5.33325 6.36689 5.63173 6.66536 5.99992 6.66536ZM9.33325 5.9987C9.33325 6.36689 9.03477 6.66536 8.66658 6.66536C8.2984 6.66536 7.99992 6.36689 7.99992 5.9987C7.99992 5.63051 8.2984 5.33203 8.66658 5.33203C9.03477 5.33203 9.33325 5.63051 9.33325 5.9987ZM9.99992 7.9987C10.3681 7.9987 10.6666 7.70022 10.6666 7.33203C10.6666 6.96384 10.3681 6.66536 9.99992 6.66536C9.63173 6.66536 9.33325 6.96384 9.33325 7.33203C9.33325 7.70022 9.63173 7.9987 9.99992 7.9987ZM7.99992 7.33203C7.99992 7.70022 7.70144 7.9987 7.33325 7.9987C6.96506 7.9987 6.66659 7.70022 6.66659 7.33203C6.66659 6.96384 6.96506 6.66536 7.33325 6.66536C7.70144 6.66536 7.99992 6.96384 7.99992 7.33203ZM4.66659 7.9987C5.03478 7.9987 5.33325 7.70022 5.33325 7.33203C5.33325 6.96384 5.03478 6.66536 4.66659 6.66536C4.2984 6.66536 3.99992 6.96384 3.99992 7.33203C3.99992 7.70022 4.2984 7.9987 4.66659 7.9987ZM2.66659 7.33203C2.66659 7.70022 2.36811 7.9987 1.99992 7.9987C1.63173 7.9987 1.33325 7.70022 1.33325 7.33203C1.33325 6.96384 1.63173 6.66536 1.99992 6.66536C2.36811 6.66536 2.66659 6.96384 2.66659 7.33203Z"
            fill="url(#paint0_linear_3085_38838)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_3085_38838"
          x="1.33325"
          y="1.33203"
          width="9.33325"
          height="7.66797"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3085_38838"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3085_38838"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3085_38838"
          x1="1.33325"
          y1="1.33203"
          x2="1.33325"
          y2="7.9987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="#F0F0F0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default USAFlagSVGIcon;
